import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import React from 'react'
import PropTypes from 'prop-types'
import Text from './text'
import Link from '@atoms/link'
import Ul from '@atoms/ul'
import Ol from '@atoms/ol'
import Abbr from '@atoms/abbr'

const propTypes = {
  html: PropTypes.string.isRequired,
  className: PropTypes.string
}

const parseListElement = (children, className) => {
  const listElemChildren = [];
  for (let i = 0; i < children.length; i++){
    const liChildren = [];
    if (children[i].name === 'li'){
      for (let x = 0; x < children[i].children.length; x++){
        liChildren.push(parseHTML(children[i].children[x], x, className))
      }
      listElemChildren.push(liChildren)
    }
  }
  return listElemChildren;
}

const SourceHTML = ({ html, className}) => {
  const replace = (domNode, index) => {
    if (domNode.name === 'ul'){
      return React.createElement(Ul, { className, key: `source-ul-${index}`}, parseListElement(domNode.children, className))
    }
    else if (domNode.name === 'ol'){
      return React.createElement(Ol, { className, key: `source-ol-${index}` }, parseListElement(domNode.children, className))
    }
    else if (domNode.name === 'p') {
      const children = []
      for (let i = 0; i < domNode.children.length; i++) {
        children.push(parseHTML(domNode.children[i], i, className))
      }
      return React.createElement(Text, { className, key: `source-p-${index}` }, children)
    }
  }
  return ReactHtmlParser(html, { transform: replace })
}

const parseHTML = (node, key, className) => {
  if (node.name === 'a') {
    let href
    let to
    let newtab = false
    const current = node.attribs.href
    if (current && /^(https)|(http)/.test(current)) {
      href = current
      newtab = true
      // Drupal adds /metrics because of how it was originally setup. We need to remove it because gatsby adds the base path automatically
    } else if (current && /^\/metrics/.test(current)) {
      to = current.slice(8)
    } else {
      to = current
    }
    return React.createElement(
      Link,
      { key: `source-link-${key}`, className, to, href, newtab  },
      node.children[0].data
    )
  } else if (node.type === 'text') {
    return node.data
  } else if (node.name === 'abbr') {
    const title = node.attribs.title;
    const text = node.children[0].data;
    return React.createElement(Abbr, { key: `source-abbr-${key}`, title: title, text: text})
  } else if (node.name === "strong") {
    return React.createElement(Text, { key: `source-text-${key}`, className, bold: true, as: "span"}, node.children[0].data)
  } else if (node.name === "br") {
    return React.createElement("br", {key: `source-br-${key}`})
  } else {
    return convertNodeToElement(node, key)
  }
}

SourceHTML.propTypes = propTypes
export default SourceHTML
